import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class Dojos extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='AllClasses'>
      <div><Link to='/'>Home</Link></div>
      <h3>Dojo's Names</h3>
      <br />
      <br />


        <div><Link to='/classestuksomrangsit'>1.Aikido Tuksom Rangsit</Link></div>
        <br />
        <div><Link to='/classestuksomromkaow'>2.Aikido Tuksom Romklao</Link></div>
        <br />
        <div><Link to='/classesbmz'>3.BMZ Dojo</Link></div>
        <br />
        <div><Link to='/classessattahip'>4.Marines Martial Arts Sattahip</Link></div>
        <br />
        <div><Link to='/classeslumpini'>5.Marines Martial Arts Lumpini</Link></div>
        <br />
        <div><Link to='/classeschula'>6.Chulalongkorn University Aikido Club</Link></div>
        <br />
        <div><Link to='/classeswongwianyai'>7.Aikido Wongwian Yai Dojo</Link></div>
        <br />
        <div><Link to='/classeschiangmai'>8.Renshinkan Dojo Chiang Mai</Link></div>
        <br />
        <div><Link to='/classeskorat'>9.Aikido Korat Dojo</Link></div>
        <br />
        <div><Link to='/classesmasakatsu'>11.Masakatsu Renbukan Dojo</Link></div>
        <br />
        <div><Link to='/classesfudokan'>12.Fudokan Dojo</Link></div>
        <br />
        <div><Link to='/rosterall'>13.Cross-Dojo Training</Link></div>

        <br />
        <div>
          Thailand's Aikido Association Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Dojos;
